import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  putOriginApiCrud,
  type PutOriginRequest,
  type PutOriginResponse,
} from "@/generated/fastapi";

export async function putOrigin(
  accessToken: string | null | undefined,
  request: PutOriginRequest,
): Promise<PutOriginResponse> {
  const response = await putOriginApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to update origin (${response.status})`);
  }

  if (
    response.data.status !== "success" &&
    response.data.status !== "pending"
  ) {
    throw new Error(response.data.message || "Failed to update origin");
  }

  return response.data;
}
